import { createApp } from 'vue'
import 'bulma'
import '@fortawesome/fontawesome-free/css/all.min.css'
import App from './App.vue'
require('@/assets/style.scss');
createApp(App).mount('#app')